/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Full_Name_LabelInputs */

const en_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Name`)
};

const de_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiger Name`)
};

const fr_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom complet`)
};

const es_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre completo`)
};

const it_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome completo`)
};

const nl_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige naam`)
};

const pl_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię i nazwisko`)
};

const fi_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koko nimi`)
};

const da_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulde navn`)
};

const sv_auth_full_name_label = /** @type {(inputs: Auth_Full_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständigt namn`)
};

/**
* | output |
* | --- |
* | "Full Name" |
*
* @param {Auth_Full_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_full_name_label = /** @type {((inputs?: Auth_Full_Name_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Full_Name_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_full_name_label(inputs)
	if (locale === "fr") return fr_auth_full_name_label(inputs)
	if (locale === "es") return es_auth_full_name_label(inputs)
	if (locale === "it") return it_auth_full_name_label(inputs)
	if (locale === "nl") return nl_auth_full_name_label(inputs)
	if (locale === "pl") return pl_auth_full_name_label(inputs)
	if (locale === "fi") return fi_auth_full_name_label(inputs)
	if (locale === "da") return da_auth_full_name_label(inputs)
	if (locale === "sv") return sv_auth_full_name_label(inputs)
	return en_auth_full_name_label(inputs)
});